"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSentry = void 0;
const web_env_1 = require("@snapchat/web-env");
// Sentry is a large package, importing dynamically
async function importSentry() {
    // exceptionFromStacktrace and computeStackTrace from previous versions are
    // deprecated and no longer available.
    // https://github.sc-corp.net/Snapchat/content-platform/commit/2446621fe4bb78ccacb7d87da569101e5dbd4b75#diff-bde589aab07db4b0a53e8b7b877b180859d21974710f40aa1b4f9b3e0e8c29c4R55
    const [{ default: Sentry }, { CaptureConsole }] = await Promise.all([
        Promise.resolve().then(() => __importStar(require("@snapchat/sentry-browser"))),
        Promise.resolve().then(() => __importStar(require("@sentry/integrations"))),
    ]);
    return { Sentry, CaptureConsole };
}
// Filtering out some urls that are too noisy
const filterUrls = [/web\/metrics/, /google-analytics/, /^blob/];
function beforeBreadcrumb(breadcrumb) {
    if ((breadcrumb.category === "fetch" || breadcrumb.category === "xhr") &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        filterUrls.some((regex) => breadcrumb.data?.url?.match?.(regex))) {
        return null;
    }
    return breadcrumb;
}
async function initSentry(allowedOrigins, dsn) {
    const allowedOriginsArr = Array.isArray(allowedOrigins) ? allowedOrigins : [allowedOrigins];
    // we only initialize sentry if we run on prod
    if ((0, web_env_1.isRunningOnServer)() ||
        allowedOriginsArr.every((origin) => origin !== window.location.origin)) {
        return Promise.resolve();
    }
    const { Sentry, CaptureConsole } = await importSentry();
    Sentry.init({
        dsn,
        beforeBreadcrumb,
        allowUrls: allowedOriginsArr,
        release: process.env.NEXT_PUBLIC_SENTRY_VERSION,
        maxBreadcrumbs: 50,
        environment: "prod",
        sampleRate: 1.0,
        tracesSampleRate: 0.01,
        defaultIntegrations: [
            new Sentry.Integrations.InboundFilters(),
            new Sentry.Integrations.FunctionToString(),
            new Sentry.Integrations.TryCatch(),
            new Sentry.Integrations.Breadcrumbs(),
            new Sentry.Integrations.LinkedErrors(),
            new Sentry.Integrations.HttpContext(),
            new CaptureConsole({ levels: ["error"] }),
        ],
    });
}
exports.initSentry = initSentry;
//# sourceMappingURL=sentry.js.map